import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Clickable from "@insite/mobius/Clickable";
import {
    carouselDot,
    carouselDotActive,
    carouselDotsContainer,
} from "@thkStore/Styles/CarouselStyles";
import { EmblaCarouselType } from "embla-carousel";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";

interface Props {
    embla: EmblaCarouselType | undefined;
}

const CarouselDots: React.FC<Props> = ({ embla }) => {
    const [snaps, setSnaps] = useState<number[]>([]);
    const [selectedIndex, setSelectedIndex] = useState(0);

    const syncFromEmbla = useCallback(() => {
        if (!embla) {
            return;
        }
        setSnaps(embla.scrollSnapList());
        setSelectedIndex(embla.selectedScrollSnap());
    }, [embla]);

    useEffect(() => {
        if (!embla) {
            return;
        }
        syncFromEmbla();
        embla.on("select", syncFromEmbla);
        embla.on("reInit", syncFromEmbla);
        return () => {
            embla.off("select", syncFromEmbla);
            embla.off("reInit", syncFromEmbla);
        };
    }, [embla, syncFromEmbla]);

    if (snaps.length <= 1) {
        return null;
    }

    return (
        <StyledWrapper {...carouselDotsContainer} data-test-selector="carouselDots">
            {snaps.map((_, index) => (
                <Clickable
                    key={index}
                    onClick={() => embla?.scrollTo(index)}
                    {...(index === selectedIndex ? carouselDotActive : carouselDot)}
                    aria-label={`Go to slide ${index + 1}`}
                    data-test-selector={`carouselDot_${index}`}
                >
                    {" "}
                </Clickable>
            ))}
        </StyledWrapper>
    );
};

export default CarouselDots;
